import favorites from 'features/favorites';
import Navigation from './navigation';

var FavoriteOffersPlugin = Navigation.Plugin.extend({
  onRendered: function () {
    var nav = this.getNavigation();
    nav.walk(function (link, path) {
      var els = nav.getDOMNodes(link);
      // Add the span to show favorite count next to the favorites link(s)
      if (link.type === 'link' && link.url.indexOf('/favorites/') > 0 && nav.getPathRegion(path).key === 'utility') {
        $(els).find('a > span').append('<span class="favorite-count"></span>');
      } else if (link.type === 'link' && link.url.indexOf('/favorites/') > 0 && nav.getPathRegion(path).key === 'expanded') {
        $(els).find('a').append('<span class="favorite-count expanded-favorite"></span>');
      }
    });
    favorites.mainNav();
  },
});

Navigation.registerPlugin(FavoriteOffersPlugin);
